import { ESTIMULO_2020, ESTIMULO_2020_BR, ESTIMULO_2020_RS, ESTIMULO_2020_RECEIVABLES } from "constants/product-constants";

export const isEstimulo = (bizId?: string | null) => {
    return bizId === ESTIMULO_2020;
};

export const isEstimuloBr = (bizId?: string | null) => {
    return bizId === ESTIMULO_2020_BR;
};

export const isEstimuloRs = (bizId?: string | null) => {
    return bizId === ESTIMULO_2020_RS;
};

export const isEstimuloReceivables = (bizId?: string | null) => {
    return bizId === ESTIMULO_2020_RECEIVABLES;
};

export const isAnyEstimuloProduct = (bizId?: string | null) => {
    return isEstimulo(bizId) || isEstimuloBr(bizId) || isEstimuloRs(bizId) || isEstimuloReceivables(bizId);
};

export const getPartnerLogoClass = (utmSource: string, productBizId?: string | null, loanApplicationUtmSource?: string | null) => {
    // Verifica se qualquer um dos valores é um produto estímulo
    const isAnyEstimulo = [utmSource, productBizId, loanApplicationUtmSource].some(value =>
        [ESTIMULO_2020, ESTIMULO_2020_BR, ESTIMULO_2020_RS, ESTIMULO_2020_RECEIVABLES].includes(value as string)
    );

    if (isAnyEstimulo) {
        return 'estimulo2020';
    }

    if (productBizId || loanApplicationUtmSource) {
        return productBizId || loanApplicationUtmSource;
    }

    return utmSource || 'partner-logo';
};
